<template>
    <div class="message-container">
        <div @click="close" class="message-header">
            {{ __('Support') }}

            <font-awesome-icon
                class="m-2"
                icon="times"
                size="1x"
                style="cursor: pointer"
            />

        </div>

        <div class="message-body" v-show="!isClosed">
            <div class="message-body-container">
                <div class="message-body-container-message" id="message">
                    <template v-if="Array.isArray(messages) && messages.length">
                        <div :key="message.id" class="pb-3" v-for="message in messages">
                            <div class="message-body-container-message-text">{{ message.text }}</div>

                            <div class="message-body-container-message-date">{{ date(message.date) }}</div>
                        </div>
                    </template>

                    <div class="message-body-container-none" v-else>
                        {{ __('No messages sent')}}
                    </div>
                </div>

                <div class="message-body-container-send">
                    <FormTextarea
                        :placeholder="__('Write message...')"
                        name="messagebody"
                        rows="1"
                        v-model="message.body"
                    />

                    <div @click="sendMessage" class="d-flex" style="cursor: pointer">
                        <button class="transparent-text-only">{{ __('Send') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { __ } from '../../translations/localization'

export default {
  name: 'MessageBox',

  data () {
    return {
      messages: [],
      message: {
        body: null
      },
      isClosed: true
    }
  },

  created () {
    this.updateMessages()
  },

  updated () {
    let message = this.$el.querySelector('#message')
    message.scrollTop = message.scrollHeight
  },


  methods: {
    date (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },

    close () {
      this.isClosed = !this.isClosed
    },

    updateMessages () {
      this.$api.message.getMessages().then((res) => {
        this.messages = res.data.reverse()
      })
    },

    sendMessage () {
      if (this.message.body) {
        this.$api.message.sendMessage(this.message.body)
          .then(() => {
            this.$toaster.success(__('Message successfully sent!'))
            this.message.body = null
            this.updateMessages()
          })
      }
    }
  }
}
</script>
